import { themes } from 'src/theme/theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: 15,
    height: 15,
    marginRight: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  hintIcon: {
    tintColor: themes.light.gray_blue[3], // Optional: Add a grey color for the hint icon
  },
  errorText: {
    textAlign: 'center',
    color: themes.light.red[3],
  },
  hintText: {
    color: themes.light.gray_blue[3],
  },
});
